'use client';

import { createContext, type ReactNode, useContext } from 'react';
import {
  type CountryShippingTimes,
  FALLBACK_COUNTRY_SHIPPING_TIMES,
} from '@/core/utils/shipping/apply-shipping-time';

const CountryShippingTimesContext = createContext<CountryShippingTimes>(
  FALLBACK_COUNTRY_SHIPPING_TIMES,
);

export function CountryShippingTimesProvider({
  children,
  times,
}: {
  children: ReactNode;
  times: CountryShippingTimes;
}) {
  return (
    <CountryShippingTimesContext.Provider value={times}>
      {children}
    </CountryShippingTimesContext.Provider>
  );
}

export function useCountryShippingTimes(): CountryShippingTimes {
  return useContext(CountryShippingTimesContext);
}
